export default __webpack_public_path__ + "static/media/qualite-quebecoise.d8bd5906.jpg";